
import React, { useState } from "react";
 
const Rtl = () => {
  const [isRTL, setIsRTL] = useState(false);
 
  const toggleRTL = () => {
    setIsRTL(!isRTL);
    document.body.classList.toggle("rtl", !isRTL);
  };
 
return (
    <div className="d-inline-block align-top">
        <button className="btn btn-info btn-sm" onClick={toggleRTL}>
            {/* Switch to*/} {isRTL ? "LTR" : "RTL"} 
        </button>
    </div>
  );
};
 
export default Rtl;